import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    listContainer: {
        marginTop: theme.spacing(1),
        '& .row': {
            width: '100%',
            height: 70,
            borderRadius: 5,
            backgroundColor: theme.palette.grey[100],
            marginBottom: theme.spacing(1),
            cursor: 'pointer',

            '&:hover': {
                opacity: 0.7,
            },

            '& .icon': {
                width: theme.spacing(5),
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.colors.blue
            },

            '& .title': {

            },

            '& .score': {
                marginLeft: 'auto'
            }
        }
    }
}));
